import React, { PureComponent } from "react";
import { Icon } from "@vitalsource/vstui";

class NullSearchPanelResults extends PureComponent {
  render() {
    return (
      <Icon {...this.props} height={231} width={358}>
        <defs>
          <polygon points="0 0.830410245 23.338 0.830410245 23.338 19 0 19" />
        </defs>
        <g fill="none" stroke="none" strokeWidth="1">
          <g transform="translate(-1052.000000, -447.000000)">
            <g transform="translate(1020.000000, 0.000000)">
              <g transform="translate(33.000000, 448.000000)">
                <polygon
                  fill="#86E0C2"
                  points="191.90877 75 196.524572 80.3407771 204 79.6404645 199.81817 85.5940152 202.565776 92.0013399 195.364667 90.3398839 189.587198 95 189.31817 88.0200983 183 84.4926306 190.036164 81.8396606"
                />
                <polygon
                  fill="#86E0C2"
                  points="233.690396 221.446097 229 223.170057 233.211657 225.4634 233.390517 230 237.241785 226.971206 242.043412 228.051098 240.211212 223.886178 243 220.016492 238.015954 220.470767 234.937965 217"
                />
                <polygon
                  fill="#75CFEC"
                  points="99.7875799 35 103.304674 39.0047676 109 38.4809297 105.814707 42.9460667 107.907746 47.7508939 102.420469 46.5056615 98.0182715 50 97.8138101 44.7651967 93 42.1191895 98.3599372 40.1302145"
                />
                <polygon
                  fill="#75CFEC"
                  points="33.0410868 131 40.5355893 140.990892 52 140.264983 45.9851746 150.728417 50.6755215 162.513041 39.4641903 158.990454 30.8982887 167 29.9847337 154.357962 20 147.523196 30.6469729 143.233495"
                />
                <polygon
                  fill="#FEC391"
                  points="286.016419 73 290.539104 79.1937925 298 78.8743034 293.744903 85.2112842 296.388327 92.4718301 289.236255 90.193345 283.408966 95 283.244026 87.2561933 277 82.9659114 284.050301 80.4574299"
                />
                <path
                  d="M350,87 L350,98"
                  stroke="#DADADA"
                  strokeLinecap="round"
                  strokeWidth="2"
                />
                <g
                  stroke="#DADADA"
                  strokeLinecap="round"
                  strokeWidth="2"
                  transform="translate(292.000000, 0.000000)"
                >
                  <path d="M63.2342222,92.7833208 L53.6955556,92.7833208" />
                  <path d="M0.447822222,0.167692453 L0.447822222,11.5878057" />
                </g>
                <path
                  d="M297,6 L288,6"
                  stroke="#DADADA"
                  strokeLinecap="round"
                  strokeWidth="2"
                />
                <path
                  d="M5,17 L5,28"
                  stroke="#DADADA"
                  strokeLinecap="round"
                  strokeWidth="2"
                />
                <path
                  d="M9,22 L0,22"
                  stroke="#DADADA"
                  strokeLinecap="round"
                  strokeWidth="2"
                />
                <path
                  d="M85,201 L85,212"
                  stroke="#DADADA"
                  strokeLinecap="round"
                  strokeWidth="2"
                />
                <path
                  d="M89,207 L80,207"
                  stroke="#DADADA"
                  strokeLinecap="round"
                  strokeWidth="2"
                />
                <path
                  d="M177.600733,157.944929 C164.082671,157.944929 150.56549,152.766002 140.251206,142.407263 C119.623521,121.690671 119.623521,88.1019596 140.251206,67.3844827 C150.56549,57.0257442 164.082671,51.8468174 177.600733,51.8468174 C191.119676,51.8468174 204.636858,57.0257442 214.951141,67.3844827 C235.578827,88.1019596 235.578827,121.690671 214.951141,142.407263 C204.636858,152.766002 191.119676,157.944929 177.600733,157.944929 M273.756386,189.167116 L238.37916,153.638298 C236.230682,151.479674 233.122919,150.880745 230.433577,151.825585 L224.115869,145.479763 C233.884004,134.219534 239.231857,119.974388 239.231857,104.895873 C239.231857,88.3629407 232.820776,72.8199673 221.18076,61.1288981 C209.539864,49.4387137 194.062714,43 177.600733,43 C161.139634,43 145.662483,49.4387137 134.021587,61.1288981 C109.992804,85.2621312 109.992804,124.529615 134.021587,148.662848 C145.662483,160.353917 161.139634,166.791746 177.600733,166.791746 C193.149236,166.791746 207.815091,161.042199 219.203173,150.554297 L225.274233,156.652409 C224.022496,159.476313 224.543099,162.900916 226.849256,165.217897 L262.226481,200.746716 C265.217086,203.751095 270.067239,203.751095 273.057844,200.746716 L273.756386,200.045163 C276.747871,197.041669 276.747871,192.171496 273.756386,189.167116"
                  fill="#FEAD64"
                />
              </g>
            </g>
          </g>
        </g>
      </Icon>
    );
  }
}

NullSearchPanelResults.displayName = "NullSearchPanelResults";
NullSearchPanelResults.vstuiName = "Icon";

export default NullSearchPanelResults;
